/* eslint-disable */

import { HiX } from "react-icons/hi";
import { Link, useLocation } from "react-router-dom";
import routes, { GROUPS } from "routes.js";
import { MdLogout } from "react-icons/md";
import { useMemo, useState } from "react";
import Cookies from "js-cookie";
import useWorkspace from "hooks/useWorkspace";
import SidebarGroup from "./SidebarGroup";

function isVisible(route, user) {
  if (!route || !route.layout) return false;
  if (route.layout !== "/admin") return false;
  if (route.superAdminOnly && !user?.superAdmin) return false;
  if (
    !user?.superAdmin &&
    user?.enabledDashboardPaths &&
    user.enabledDashboardPaths.length > 0 &&
    !user.enabledDashboardPaths.includes(route.path)
  )
    return false;
  return true;
}

function NavItem({ route, active }) {
  return (
    <Link to={`${route.layout}/${route.path}`}>
      <div className="relative mb-1 flex hover:cursor-pointer">
        <span
          className={`my-[2px] flex w-full cursor-pointer items-center gap-3 px-7 py-2 transition ${
            active
              ? "bg-info-50/60 font-semibold text-info-700 dark:bg-navy-700 dark:text-white"
              : "font-medium text-gray-600 hover:bg-surface-muted dark:text-gray-300 dark:hover:bg-navy-700/60"
          }`}
        >
          <span className="shrink-0">{route.icon}</span>
          <span className="truncate text-sm">{route.name}</span>
        </span>
        {active ? (
          <span className="absolute end-0 top-1.5 h-8 w-1 rounded-lg bg-info-500" />
        ) : null}
      </div>
    </Link>
  );
}

const WORKSPACE_LABELS = {
  ops: "العمليات",
  analytics: "التحليلات",
};

const Sidebar = ({ open, onClose, user }) => {
  const [isLogout, setIsLogout] = useState(false);
  const { workspace, switchTo } = useWorkspace(
    user?.superAdmin ? "analytics" : "ops"
  );
  const location = useLocation();

  const handleLogout = () => {
    Cookies.remove("token");
    window.location.href = "/auth/sign-in";
  };

  const visibleRoutes = useMemo(
    () => routes.filter((r) => r && isVisible(r, user)),
    [user]
  );

  const workspaceRoutes = useMemo(
    () => visibleRoutes.filter((r) => (r.workspace || "ops") === workspace),
    [visibleRoutes, workspace]
  );

  const grouped = useMemo(() => {
    const acc = {};
    for (const r of workspaceRoutes) {
      const g = r.group || "ops";
      if (!acc[g]) acc[g] = [];
      acc[g].push(r);
    }
    return acc;
  }, [workspaceRoutes]);

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex h-full w-72 flex-col bg-white shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 block cursor-pointer end-4 xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className="mt-[40px] flex flex-col gap-3 px-7">
        <div className="text-[20px] font-bold uppercase text-navy-700 dark:text-white">
          المقاول <span className="font-medium">- لوحة تحكم</span>
        </div>
        <div
          role="tablist"
          className="flex rounded-xl bg-surface-muted p-1 dark:bg-navy-900"
        >
          {(["ops", "analytics"]).map((w) => (
            <button
              key={w}
              type="button"
              onClick={() => switchTo(w)}
              className={`flex-1 rounded-lg px-2 py-1.5 text-xs font-semibold transition ${
                workspace === w
                  ? "bg-white text-navy-700 shadow-card dark:bg-navy-700 dark:text-white"
                  : "text-gray-500 hover:text-navy-700 dark:hover:text-white"
              }`}
            >
              {WORKSPACE_LABELS[w]}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-5 mb-3 h-px bg-gray-200 dark:bg-white/20" />

      <ul className="custom_scrollbar mb-auto flex-1 overflow-y-auto pb-4 pt-1">
        {Object.keys(GROUPS).map((gKey) => {
          const items = grouped[gKey];
          if (!items || items.length === 0) return null;
          return (
            <SidebarGroup
              key={gKey}
              label={GROUPS[gKey].label}
              defaultOpen
            >
              {items.map((r) => (
                <NavItem
                  key={r.path}
                  route={r}
                  active={location.pathname.includes(r.path)}
                />
              ))}
            </SidebarGroup>
          );
        })}
      </ul>

      {!isLogout ? (
        <button
          onClick={() => setIsLogout(true)}
          className="flex items-center gap-2 bg-blueSecondary px-4 py-4 text-white hover:bg-blue-900"
        >
          <MdLogout className="h-6 w-6" />
          <span>تسجيل الخروج</span>
        </button>
      ) : (
        <div className="flex items-center justify-around text-white">
          <button
            onClick={handleLogout}
            className="flex-1 bg-blueSecondary px-4 py-4 hover:bg-blue-900"
          >
            نعم
          </button>
          <button
            onClick={() => setIsLogout(false)}
            className="flex-1 bg-blueSecondary px-4 py-4 hover:bg-blue-900"
          >
            لا
          </button>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
